import React from "react"

import ScheduleView from "../schedule/ScheduleView"

interface SortationScheduleContentProps {
  selectedDate: Date
  onSelectedDateChange: (date: Date) => void
}

const SortationScheduleContent: React.FC<SortationScheduleContentProps> = ({
  selectedDate,
  onSelectedDateChange,
}) => {
  return (
    <ScheduleView
      scheduleType="sortation"
      selectedDate={selectedDate}
      onSelectedDateChange={onSelectedDateChange}
    />
  )
}

export default SortationScheduleContent
